export enum ReportStepDirection {
  Forward = 'forward',
  Backward = 'backward',
}
